$.fn.BlogCategories = function() {
  let self = this

  self.closest('.row').css('position', 'relative').css('z-index', '1');

  self.find('.blog-filters__title').click(function() {
    self.maxHeight();
    self.toggleClass('--filters-open')
  })

  self.maxHeight = function () {
    self.css('--max-height', self.find('.blog-filters__wrapper').outerHeight() + 'px');
  }

  $(window).click(function() {
    $('.blog-filters').removeClass('--filters-open');
  });

  $('.blog-filters').click(function(event){
    event.stopPropagation();
  });

  return function() {
    $(window).on('resize load orientationchange', self.maxHeight)
    return self
  }()
}
